import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Routes from './Routes';
import PRNotifications from './components/notifications/PRNotifications';
import CookieConsent from './components/legal/CookieConsent';
import './styles/tailwind.css';
import useGoogleAnalytics from './hooks/useGoogleAnalytics';

function App() {
  // Initialize Google Analytics for the entire application
  useGoogleAnalytics();

  return (
    <HelmetProvider>
      <AuthProvider>
        <Routes />
        <PRNotifications />
        <CookieConsent />
      </AuthProvider>
    </HelmetProvider>
  )
}

export default App